import SimpleLineIcon from "react-simple-line-icons";

const TabNavigations = [
  {
    title: "خانه",
    icon: <SimpleLineIcon name="home font-simple-line-icons f-20" />,
    url: "/",
  },
  {
    title: "بارهای من",
    icon: <SimpleLineIcon name="calendar font-simple-line-icons f-20" />,
    url: "/user/loads",
  },
  {
    title: "گزارشات مالی",
    icon: <SimpleLineIcon name="calculator font-simple-line-icons f-20" />,
    url: "/user/transactions",
  },
  {
    title: "پروفایل",
    icon: <SimpleLineIcon name="user font-simple-line-icons f-20" />,
    url: "/profile",
  },
];

export default TabNavigations;
